import React, {FC, useEffect, useMemo, useState} from 'react';
import styled from "styled-components";
import {
  IChartererOrder,
} from "../../../../../store/reducers/chartererRequestsReducer/chartererRequestsReducerTypes";
// import TrashIcon from "../../../../../media/icons/delete.svg?react";
import CloseIcon from "../../../../../media/icons/close.svg?react";
import FlagIcon from "../../../../../media/icons/flag.svg?react";
import FlagFilledIcon from "../../../../../media/icons/flag_filled.svg?react";
import DocumentSearchIcon from "../../../../../media/icons/document-search.svg?react";
import {formatDate} from "../../../../../utils/helpers/dateHelpers/dateHelpers";
import {Col, Row} from "antd";
import {DetailItem} from "../../../../../components/businessCommon/detailItem/DetailItem";
import CollapseIcon from "../../../../../media/icons/collapse.svg?react";
import ExpandIcon from "../../../../../media/icons/expand.svg?react";
import PaxIcon from "../../../../../media/icons/pax.svg?react";
import RouteArrowIcon from "../../../../../media/icons/route_arrow_medium.svg?react";
import RouteMiniArrowIcon from "../../../../../media/icons/route_mini_arrow.svg?react";
import {ArchiveOrderModal} from "./ArchiveOrderModal";
import {useAppDispatch, useAppSelector} from "../../../../../store/store";
import {useUserTimezoneOffset} from "../../../../../hooks/useUserTimezone";
import {DisplayPlaneCategories} from "../../../../../utils/helpers/textDisplayHelpers/DisplayPlaneCategories";
import {DisplayYesOrNo} from "../../../../../utils/helpers/textDisplayHelpers/DisplayYesOrNo";
import {DisplayAirport} from "../../../../../utils/helpers/textDisplayHelpers/DisplayAirport";
import {defineMessages, useIntl} from "react-intl";
import {CommonDetailsMessages} from "../../../../../intl/commonMessages/CommonDetailsMessages";
import {CommonButtonMessages} from "../../../../../intl/commonMessages/CommonButtonMessages";
import {OrderTypeShield} from "../../../../../components/businessCommon/orderType/OrderTypeShield";
import {DisplayFullName} from "../../../../../utils/helpers/textDisplayHelpers/DisplayFullName";
import {FlyRouteMini} from "../../../../../components/businessCommon/flyRoute/FlyRouteMini";
import {IAirport} from "../../../../../store/reducers/fleetReducer/fleetReducerTypes";
import {FlyCompanies} from "../../../../../components/businessCommon/flyCompanies/FlyCompanies";
import {CustomLinkButton} from "../../../../../components/UI/Buttons/CustomLinkButton";
import {VerticalDivider} from "../../../../../components/UI/VerticalDivider/VerticalDivider";
import {
  IFreighterOrderRoute
} from "../../../../../store/reducers/freighterRequestsReducer/freighterRequestsReducerTypes";
import {useIsMobile} from "../../../../../hooks/useWindowSize";
import {mediaScreenSizes} from "../../../../../utils/constans/styles/screenSizes";
import {CustomButton} from "../../../../../components/UI/AntCustom/CustomButton";
import {updateOrderFavorite, archiveOrder, getChartererOrderList, clearArchiveOrder, getOrderListCounts} from "../../../../../store/reducers/chartererRequestsReducer/chartererRequestsReducer";
import {PastResponsesModal} from "../../../Shared/components/PastResponsesModal";
import {OrderRequestStatusEnum} from "../../../../../utils/constans/statuses/orderRequestStatuses";
import {IChartererOrderRequestFromOrder} from "../../../../../store/reducers/chartererRequestsReducer/chartererRequestsReducerTypes";
import {PlaneImage} from "../../../../../components/businessCommon/planeImage/PlaneImage";
import {ChatButton} from "../../../../../components/businessCommon/chat/ChatButton";
import {useChat} from "../../../../../components/businessCommon/chat/useChat";
import {ChatModal} from "../../../../../components/businessCommon/chat/ChatModal";
import {DisplayFlyPrice} from "../../../../../utils/helpers/textDisplayHelpers/DisplayFlyPrice";
import {useCurrencyConverter} from "../../../../../hooks/useCurrencyConverter";
import {useOrderRequestStatusName} from "../../../../../utils/constans/statuses/orderRequestStatuses";
import {AcceptButton} from "../../../../../components/UI/Buttons/AcceptButton";
import {DeclineButton} from "../../../../../components/UI/Buttons/DeclineButton";
import {
  OrderOrderRequestFlightDrawer
} from "../../../../../components/businessCommon/flightDrawer/wrappers/OrderOrderRequestFlightDrawer";
import InfoIcon from "../../../../../media/icons/info-icon.svg?react";
import {CommonFormMessages} from "../../../../../intl/commonMessages/CommonFormMessages";
import {changeOrderRequestWithdraw, clearChangeOrderRequestWithdraw} from "../../../../../store/reducers/freighterRequestsReducer/freighterRequestsReducer";
import {RenderConfirmModal} from "../../../../../components/UI/StatusModals/renderSuccessModal";
import {message as antdMessage} from "antd";


const OrderHeaderWrapper = styled.div`
  padding: 15px 16px 18px 16px;
  display: flex;
  flex-direction: column;
  row-gap: 18px;
  background: #FAFAFA;
  border-radius: 10px;
  border: 1px solid #D9D9D9;

  & > hr {
    border: none;
    height: 1px;
    background: #D9D9D9;
    width: 100%;
    margin: 0;
  }
`;

const OrderHeaderMainInfoWrapper = styled.div`
  display: flex;
  flex-direction: row;
  column-gap: 16px;

  @media (max-width: ${mediaScreenSizes.mobile}) {
    flex-direction: column;
    row-gap: 16px;
  }
`;

const OrderBrokerMobileWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding-bottom: 16px;
  border-bottom: 1px solid #D9D9D9;
`;

const OrderBroker = styled.div`
  width: 120px;
  display: flex;
  flex-direction: column;
  row-gap: 5px;

  & > div {
    :last-child {
      font-weight: 700;
      font-size: 14px;
      line-height: 22px;
      color: #000000;
    }
  }

  @media (max-width: ${mediaScreenSizes.mobile}) {
    width: unset;
    flex-grow: 1;
    row-gap: 8px;

    & > div {
      :last-child {
        line-height: 17px;
      }
    }
  }
`;

const OrderHeaderMainInfoItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  row-gap: 7px;

  & > div {
    :nth-child(1) {
      font-weight: 400;
      font-size: 14px;
      line-height: 120%;
      color: #808080;
    }

    :nth-child(2) {
      font-weight: 600;
      font-size: 14px;
      line-height: 17px;
      color: #000000;
    }
  }
`;

const ArchiveSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  column-gap: 8px;

  & > div {
    :last-child {
      cursor: pointer;
    }
  }
`;

const ActionButtonWrapper = styled(CustomButton)`
  width: 45px;
  height: 35px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #FAFAFA;
  border: 1px solid #D9D9D9;
  border-radius: 5px;

  svg {
    width: 16px;
    height: 16px;
  }

  &:hover {
    border-color: #1890FF;
  }
`;

const FavoriteButtonWrapper = styled(CustomButton)<{ $isFavorite?: boolean }>`
  width: 45px;
  height: 35px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #FAFAFA;
  border: 1px solid ${props => props.$isFavorite ? '#1890FF' : '#D9D9D9'};
  border-radius: 5px;
  color: rgba(0, 0, 0, 0.88);

  svg {
    width: 16px;
    height: 16px;
  }

  &:hover {
    border-color: #1890FF !important;
    color: rgba(0, 0, 0, 0.88) !important;
  }
`;

const OrderHeaderAdditionalInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 10px;
  padding-bottom: 16px;

  @media (max-width: ${mediaScreenSizes.mobile}) {
    row-gap: 8px;
    padding-bottom: 0;
  }
`;

const AircraftOptionsSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  margin-top: 16px;
`;

const AircraftOptionsTitle = styled.div`
  font-family: Inter, sans-serif;
  font-weight: 600;
  font-size: 12px;
  line-height: 22px;
  color: #000000;
`;

const AircraftOptionsCard = styled.div`
  background: #FAFAFA;
  border: 1px solid #E4E4E4;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
`;

const AircraftCardHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 24px 24px 0 24px;
`;

const AircraftCardHeaderLeft = styled.div`
  display: flex;
  gap: 36px;
  align-items: center;
`;

const AircraftCardHeaderLeftBlock = styled.div`
  display: flex;
  gap: 18px;
  align-items: center;
`;

const AircraftCardNameBlock = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const AircraftCardName = styled.div`
  font-family: Inter, sans-serif;
  font-weight: 600;
  font-size: 14px;
  line-height: 22px;
  color: #000000;
  letter-spacing: -0.14px;
  white-space: nowrap;
`;

const AircraftCardDottedLine = styled.div`
  width: 140.383px;
  height: 1px;
  background-image: repeating-linear-gradient(
    to right,
    #000 0px,
    #000 14.048px,
    transparent 14.048px,
    transparent 18.048px
  );
  margin-top: 1px;
`;

const AircraftCardCompany = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const AircraftCardCompanyName = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;

const AircraftCardCompanyText = styled.div`
  font-family: Inter, sans-serif;
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  color: #000000;
  width: 111px;
`;

const AircraftCardHeaderRight = styled.div`
  display: flex;
  gap: 39px;
  align-items: center;
`;

const AircraftCardPriceBlock = styled.div`
  display: flex;
  gap: 4px;
  align-items: center;
  width: 100px;
`;

const AircraftCardPrice = styled.div`
  color: #000000;
  font-family: Inter, sans-serif;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: -0.2px;
`;

const InfoIconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 16px;
  height: 16px;
  
  svg {
    width: 16px;
    height: 16px;
  }
`;

const AircraftCardStatusBlock = styled.div`
  display: flex;
  gap: 30px;
  align-items: center;
`;

const AircraftCardStatusBadge = styled.div<{ $status: OrderRequestStatusEnum }>`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 30px;
  padding: 2px 13px;
  border-radius: 23px;
  width: 100px;
  background: ${({$status}) => {
    if ($status === OrderRequestStatusEnum.DECLINED) return "#E7C4C4";
    return "#E0E0E0";
  }};
`;

const AircraftCardStatusText = styled.div`
  font-family: Inter, sans-serif;
  font-weight: 500;
  font-size: 12px;
  line-height: 22px;
  color: #000000;
  white-space: nowrap;
`;

const AircraftCardActions = styled.div`
  display: flex;
  gap: 8px;
  align-items: flex-end;
`;

const AircraftCardDetails = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  align-items: center;
  padding: 24px;
  position: relative;
`;

const AircraftCardImage = styled.div`
  width: 100px;
  height: 70px;
  border-radius: 5px;
  overflow: hidden;
  background: #FFFFFF;
  flex-shrink: 0;
`;

const AircraftCardDetailItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const AircraftCardDetailLabel = styled.div`
  font-family: Inter, sans-serif;
  font-weight: 600;
  font-size: 14px;
  line-height: 22px;
  color: #000000;
  white-space: nowrap;
`;

const AircraftCardDetailValue = styled.div`
  font-family: Inter, sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  color: #000000;
  letter-spacing: -0.14px;
  white-space: nowrap;
`;

const AircraftCardPeriodDates = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;

const FlyRouteBigCards = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 7px;
`;

const FlyRouteBigCardWrapper = styled.div`
  display: flex;
  padding: 16px 24px;
  background: #FFFFFF;
  border: 1px solid #D9D9D9;
  border-radius: 5px;
`;

const FlyRouteBigCardRoutesSection = styled.div`
  display: grid;
  grid-template-columns: 5fr 1fr 5fr;
  align-items: center;
  flex-grow: 1;

  & > div {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;

    & > div {
      font-weight: 400;
      font-size: 14px;
      line-height: 22px;
      color: #000000;
      opacity: 0.5;

      :last-child {
        opacity: 1;
        display: flex;
        flex-direction: row;
        column-gap: 7px;

        & > div {
          :nth-child(1) {
            font-weight: 600;
            font-size: 20px;
            line-height: 22px;
          }

          :nth-child(2) {
            font-weight: 400;
            font-size: 12px;
            line-height: 22px;
            opacity: 0.5;
          }
        }
      }
    }
  }
`;

const FlyRouteBigCardPaxSection = styled.div`
  padding: 0 0 0 16px;
  width: 121px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  & > div {
    color: #000000;

    :nth-child(1) {
      font-weight: 400;
      font-size: 14px;
      line-height: 22px;
      opacity: 0.5;
    }

    :nth-child(2) {
      display: flex;
      flex-direction: row;
      align-items: center;
      row-gap: 4px;
      font-weight: 400;
      font-size: 16px;
      line-height: 19px;

      & > svg > path {
        fill: #000000;
      }
    }
  }
`;

const MoreInfoMobileButton = styled.div`
  display: flex;
  flex-direction: row;
  column-gap: 8px;
  align-items: center;
  justify-content: center;
  color: #1890FF;

  svg > path {
    fill: #1890FF;
  }
`;

const FlyRouteSmallCardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px;
  background: #ffffff;
  border-radius: 5px;
  border: 1px solid #D9D9D9;
  row-gap: 16px;

  div {
    font-size: 14px;
    line-height: 22px;
    letter-spacing: -0.01em;
    color: #000000;
  }

  & > div {
    :nth-child(1) {
      display: flex;
      flex-direction: column;
      row-gap: 1px;

      & > div {
        :nth-child(1) {
          font-weight: 400;
          opacity: 0.5;
        }

        :nth-child(2) {
          font-weight: 600;
          display: flex;
          flex-direction: row;
          column-gap: 8px;
          align-items: center;
        }
      }
    }

    :nth-child(2) {
      display: flex;
      flex-direction: row;
      column-gap: 24px;
      align-items: center;

      & > div {
        :nth-child(1) {
          font-weight: 400;
          opacity: 0.5;
        }

        :nth-child(2) {
          display: flex;
          align-items: center;
          flex-direction: row;
          column-gap: 4px;

          svg > path {
            fill: #000000;
          }
        }
      }
    }
  }
`;


const OrderHeaderMessages = defineMessages({
  title: {
    id: "orderHeader.title",
    defaultMessage: "Request",
  },
  companies: {
    id: "orderHeader.companies",
    defaultMessage: "Companies",
  },
  dateCreated: {
    id: "orderHeader.dateCreated",
    defaultMessage: "Creation date",
  },
  aircraftOptions: {
    id: "orderRouteCharterCard.aircraftOptions",
    defaultMessage: "Варианты самолетов",
  },
  availabilityPeriod: {
    id: "orderRouteCharterCard.availabilityPeriod",
    defaultMessage: "Период доступности",
  },
  arrivalTime: {
    id: "orderRouteCharterCard.arrivalTime",
    defaultMessage: "Время подлета",
  },
  baseAirport: {
    id: "orderRouteCharterCard.baseAirport",
    defaultMessage: "Аэродром базирования",
  },
  aircraftCategory: {
    id: "orderRouteCharterCard.aircraftCategory",
    defaultMessage: "Категория самолета",
  },
  confirmDeclineMessage: {
    id: "orderHeader.confirmDeclineMessage",
    defaultMessage: "Are you sure you want to decline this offer?",
  },
  successDeclined: {
    id: "orderHeader.successDeclined",
    defaultMessage: "Offer has been successfully declined",
  },
  errorDeclineFailed: {
    id: "orderHeader.errorDeclineFailed",
    defaultMessage: "Failed to decline the offer",
  },
  confirmDeclineAllMessage: {
    id: "orderHeader.confirmDeclineAllMessage",
    defaultMessage: "Are you sure you want to decline and archive this request?",
  },
  noOrderRequestsToDecline: {
    id: "orderHeader.noOrderRequestsToDecline",
    defaultMessage: "No offers to decline",
  },
  successDeclinedAndArchived: {
    id: "orderHeader.successDeclinedAndArchived",
    defaultMessage: "Request has been declined and archived",
  },
})

interface IOrderRouteHeader {
  order: IChartererOrder;
}

interface IAircraftOptionCard {
  order: IChartererOrder;
  orderRequest: IChartererOrderRequestFromOrder;
}

const AircraftOptionCard: FC<IAircraftOptionCard> = ({order, orderRequest}) => {
  const intl = useIntl();
  const dispatch = useAppDispatch();
  const offset = useUserTimezoneOffset();
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [isChatOpened, setIsChatOpened] = useState(false);
  const orderRequestStatusName = useOrderRequestStatusName(orderRequest.status);
  const userId = useAppSelector(state => state.user.oneItemObject.item.id);
  const chat = useChat(userId, orderRequest.freighterUser.id, order.id);
  const userCurrency = useAppSelector(state => state.company.oneItemObject.item?.currency);
  const {convertSync, isReady} = useCurrencyConverter();
  
  const {
    isLoading: isDeclineLoading,
    isSuccess: isDeclineSuccess,
    errorMessage: declineErrorMessage,
  } = useAppSelector(state => state.freighterRequests.changeOrderRequestWithdraw);
  
  // Конвертация цены в валюту пользователя
  const priceInUserCurrency = useMemo(() => {
    if (!userCurrency || !isReady || !orderRequest.price || !orderRequest.currency) {
      return null;
    }
    
    // Если валюта совпадает, конвертация не нужна
    if (orderRequest.currency.id === userCurrency.id) {
      return null;
    }
    
    return convertSync(orderRequest.price, orderRequest.currency.id, userCurrency.id);
  }, [orderRequest.price, orderRequest.currency, userCurrency, convertSync, isReady]);
  
  const unreadChatNotifications = useAppSelector(state => 
    state.notifications.unreadOnlyNotifications.filter(n => 
      n.entityId === chat?.chatId && 
      n.metadata.orderId === order.id &&
      n.metadata.orderRequestId === orderRequest.orderRequestId
    )
  );

  const handleChatClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    setIsChatOpened(true);
  };

  const handleAccept = () => {
    // TODO: Implement accept action
  };

  const handleDecline = () => {
    const confirmMessage = intl.formatMessage(OrderHeaderMessages.confirmDeclineMessage);
    console.log('handleDecline', orderRequest.orderRequestId);
    RenderConfirmModal(confirmMessage, async () => {
      dispatch(changeOrderRequestWithdraw({
        orderRequestId: orderRequest.orderRequestId,
        orderRequestStatus: OrderRequestStatusEnum.DECLINED,
      }));
    }, intl);
  };

  useEffect(() => {
    if (!isDeclineLoading) {
      if (isDeclineSuccess) {
        antdMessage.success(intl.formatMessage(OrderHeaderMessages.successDeclined));
        // Refresh the order list to reflect the changes
        dispatch(getChartererOrderList({
          page: 1,
          types: [],
          showArchived: false,
        }));
        dispatch(clearChangeOrderRequestWithdraw());
      } else if (declineErrorMessage) {
        antdMessage.error(declineErrorMessage);
        dispatch(clearChangeOrderRequestWithdraw());
      }
    }
  }, [isDeclineLoading, isDeclineSuccess, declineErrorMessage, intl, dispatch]);

  const orderRouteOrderRequests = orderRequest.orderRouteOrderRequests;
  const firstRouteRequest = orderRouteOrderRequests.length > 0 ? orderRouteOrderRequests[0] : null;
  const lastRouteRequest = orderRouteOrderRequests.length > 0 ? orderRouteOrderRequests[orderRouteOrderRequests.length - 1] : null;
  
  const availabilityStartDate = firstRouteRequest?.orderRoute.departureDate;
  const availabilityEndDate = lastRouteRequest?.arrivalDate || null;
  
  const arrivalTime = lastRouteRequest?.arrivalDate ? formatDate(lastRouteRequest.arrivalDate, offset, "time") : null;
  const arrivalAirport = lastRouteRequest?.orderRoute.airportTo ? DisplayAirport(lastRouteRequest.orderRoute.airportTo, "codes") : null;
  
  const baseAirport = orderRequest.plane?.baseAirport ? DisplayAirport(orderRequest.plane.baseAirport, "location_and_name") : null;
  const aircraftCategory = orderRequest.plane?.planeType?.planeCategory?.name || null;
  const planeTypeName = orderRequest.plane?.planeType?.name || orderRequest.freighterCompany.name;

  return (
    <>
      <AircraftOptionsCard>
        <AircraftCardHeader>
          <AircraftCardHeaderLeft>
            <AircraftCardHeaderLeftBlock>
              <AircraftCardNameBlock>
                <AircraftCardName>
                  {planeTypeName}
                </AircraftCardName>
                <AircraftCardDottedLine />
              </AircraftCardNameBlock>
            </AircraftCardHeaderLeftBlock>
            <AircraftCardCompany>
              <AircraftCardCompanyName>
                <AircraftCardCompanyText>{orderRequest.freighterCompany.name}</AircraftCardCompanyText>
                <ChatButton hasNewMessages={unreadChatNotifications.length > 0} onClick={handleChatClick} />
              </AircraftCardCompanyName>
            </AircraftCardCompany>
          </AircraftCardHeaderLeft>

          <AircraftCardHeaderRight>
            <AircraftCardPriceBlock>
              <AircraftCardPrice>
                {priceInUserCurrency && userCurrency ? (
                  <>
                    {DisplayFlyPrice(priceInUserCurrency, userCurrency, intl.formatMessage(CommonDetailsMessages.onRequest))}
                    {orderRequest.currency.id !== userCurrency.id && (
                      <span style={{ fontSize: '12px', color: '#666', marginLeft: '8px' }}>
                        ({DisplayFlyPrice(orderRequest.price, orderRequest.currency)})
                      </span>
                    )}
                  </>
                ) : (
                  DisplayFlyPrice(orderRequest.price, orderRequest.currency, intl.formatMessage(CommonDetailsMessages.onRequest))
                )}
              </AircraftCardPrice>
              {orderRequest.price && orderRequest.currency && (
                <InfoIconWrapper>
                  <InfoIcon />
                </InfoIconWrapper>
              )}
            </AircraftCardPriceBlock>

            <AircraftCardStatusBlock>
              <AircraftCardStatusBadge $status={orderRequest.status}>
                <AircraftCardStatusText>{orderRequestStatusName}</AircraftCardStatusText>
              </AircraftCardStatusBadge>
              <AircraftCardActions>
                <div
                  style={{
                    opacity: orderRequest.status === OrderRequestStatusEnum.OFFERED ? 1 : 0,
                    pointerEvents: orderRequest.status === OrderRequestStatusEnum.OFFERED ? 'auto' : 'none'
                  }}
                >
                  <AcceptButton
                    active={false}
                    onClick={handleAccept}
                  />
                </div>
                {(orderRequest.status === OrderRequestStatusEnum.OFFERED || orderRequest.status === OrderRequestStatusEnum.NOT_OFFERED) && (
                  <DeclineButton
                    active={false}
                    onClick={handleDecline}
                  />
                )}
              </AircraftCardActions>
            </AircraftCardStatusBlock>
          </AircraftCardHeaderRight>
        </AircraftCardHeader>

        <AircraftCardDetails>
          <AircraftCardImage>
            <PlaneImage files={orderRequest.plane?.imageFiles || []} width="100px" height="70px" />
          </AircraftCardImage>

          <AircraftCardDetailItem style={{width: '250px'}}>
            <AircraftCardDetailLabel>
              {intl.formatMessage(OrderHeaderMessages.availabilityPeriod)}
            </AircraftCardDetailLabel>
            {availabilityStartDate && availabilityEndDate && firstRouteRequest && lastRouteRequest ? (
              <AircraftCardPeriodDates>
                <AircraftCardDetailValue>
                  {formatDate(availabilityStartDate, offset, "datetime")}
                </AircraftCardDetailValue>
                <RouteMiniArrowIcon style={{width: '9px', height: '0px'}} />
                <AircraftCardDetailValue>
                  {formatDate(availabilityEndDate, offset, "datetime")}
                </AircraftCardDetailValue>
              </AircraftCardPeriodDates>
            ) : (
              <AircraftCardDetailValue style={{opacity: 0.5}}>
                {intl.formatMessage(CommonFormMessages.noData)}
              </AircraftCardDetailValue>
            )}
          </AircraftCardDetailItem>

          <AircraftCardDetailItem>
            <AircraftCardDetailLabel>
              {intl.formatMessage(OrderHeaderMessages.arrivalTime)}
            </AircraftCardDetailLabel>
            <AircraftCardDetailValue>
              {arrivalTime && arrivalAirport ? (
                `${arrivalTime} ${arrivalAirport}`
              ) : (
                <span style={{opacity: 0.5}}>{intl.formatMessage(CommonFormMessages.noData)}</span>
              )}
            </AircraftCardDetailValue>
          </AircraftCardDetailItem>

          <AircraftCardDetailItem>
            <AircraftCardDetailLabel>
              {intl.formatMessage(OrderHeaderMessages.baseAirport)}
            </AircraftCardDetailLabel>
            <AircraftCardDetailValue>
              {baseAirport || <span style={{opacity: 0.5}}>{intl.formatMessage(CommonFormMessages.noData)}</span>}
            </AircraftCardDetailValue>
          </AircraftCardDetailItem>

          <AircraftCardDetailItem>
            <AircraftCardDetailLabel>
              {intl.formatMessage(OrderHeaderMessages.aircraftCategory)}
            </AircraftCardDetailLabel>
            <AircraftCardDetailValue>
              {aircraftCategory || <span style={{opacity: 0.5}}>{intl.formatMessage(CommonFormMessages.noData)}</span>}
            </AircraftCardDetailValue>
          </AircraftCardDetailItem>
        </AircraftCardDetails>
      </AircraftOptionsCard>

      {isDrawerOpen && (
        <OrderOrderRequestFlightDrawer 
          isOpen={isDrawerOpen} 
          setIsOpen={setIsDrawerOpen}
          order={order} 
          orderRequest={orderRequest}
          openChat={() => setIsChatOpened(true)} 
        />
      )}

      {isChatOpened && chat && (
        <ChatModal 
          chat={chat}
          isVisible={isChatOpened}
          setIsVisible={setIsChatOpened}
        />
      )}
    </>
  );
};

export const OrderHeader: FC<IOrderRouteHeader> = ({order}) => {
  const intl = useIntl();
  const dispatch = useAppDispatch();
  const isMobile = useIsMobile();
  const offset = useUserTimezoneOffset();
  const [isMoreInfoExpanded, setIsMoreInfoExpanded] = useState<boolean>(false);
  const [isArchiveModalOpen, setIsArchiveModalOpen] = useState<boolean>(false);
  const [isFavorite, setIsFavorite] = useState<boolean>(order.isFavorite);
  const [isPastResponsesModalOpen, setIsPastResponsesModalOpen] = useState<boolean>(false);
  const archiveHandledRef = React.useRef<boolean>(false);
  
  const {
    isLoading: isDeclineLoading,
    isSuccess: isDeclineSuccess,
    errorMessage: declineErrorMessage,
  } = useAppSelector(state => state.freighterRequests.changeOrderRequestWithdraw);
  
  const {
    isLoading: isArchiveLoading,
    isSuccess: isArchiveSuccess,
    errorMessage: archiveErrorMessage,
  } = useAppSelector(state => state.chartererRequests.delete);

  useEffect(() => {
    setIsFavorite(order.isFavorite);
  }, [order.isFavorite]);

  const allOrderAirports: IAirport[] = useMemo(() => order.orderRoutes.reduce((acc, cur, index) => {
    if (index === 0)
      acc.push(cur.airportFrom);

    acc.push(cur.airportTo);
    return acc;
  }, [] as IAirport[]), [order.orderRoutes])

  const firstRoute = order.orderRoutes[0];
  const lastRoute = order.orderRoutes.slice(-1)[0];
  const isOnlyRoute = firstRoute.id === lastRoute.id;

  const moreInfo = <>
    {!isMobile && <hr/>}

    <OrderHeaderAdditionalInfoWrapper>
      {isMobile && <Col span={24}>
        <DetailItem label={intl.formatMessage(OrderHeaderMessages.dateCreated)}
                    value={formatDate(order.createdDate, offset, "date")}
                    size={'small'}/>
      </Col>}

      {!isMobile && <FlyRouteBigCards>
        {order.orderRoutes.map(orderRoute => <FlyRouteBigCard key={orderRoute.id} orderRoute={orderRoute}/>)}
      </FlyRouteBigCards>}

      {isMobile && order.orderRoutes.map(orderRoute => <FlyRouteSmallCard key={orderRoute.id}
                                                                          orderRoute={orderRoute}/>)}

      {isMobile &&
        <>
          <Col span={24}>
            <DetailItem label={intl.formatMessage(CommonDetailsMessages.planeCategories)}
                        value={DisplayPlaneCategories(order.planeCategories, intl)} size={'small'}/>
          </Col>
          <Col span={24}>
            <DetailItem label={intl.formatMessage(CommonDetailsMessages.companionsAllowed)}
                        value={DisplayYesOrNo(order.companionsAllowed, intl)} size={'small'}/>
          </Col>
        </>
      }

      {!isMobile && <Row gutter={10}>
        <Col flex={1}>
          <DetailItem label={intl.formatMessage(CommonDetailsMessages.planeCategories)}
                      value={DisplayPlaneCategories(order.planeCategories, intl)}/>
        </Col>
        <Col>
          <DetailItem label={intl.formatMessage(CommonDetailsMessages.companionsAllowed)}
                      value={DisplayYesOrNo(order.companionsAllowed, intl)}/>
        </Col>
      </Row>}

      {/*<Row>*/}
      {/*  <Col flex={1}>*/}
      {/*    <DetailItem label={intl.formatMessage(CommonDetailsMessages.comment)}*/}
      {/*                value={DisplayComment(order.comment)}*/}
      {/*                size={isMobile ? 'small' : 'default'}/>*/}
      {/*  </Col>*/}
      {/*</Row>*/}
    </OrderHeaderAdditionalInfoWrapper>

    {order.nestedOrderRequests.length > 0 && (
      <AircraftOptionsSection>
        <AircraftOptionsTitle>{intl.formatMessage(OrderHeaderMessages.aircraftOptions)}</AircraftOptionsTitle>
        {order.nestedOrderRequests.map((orderRequest) => (
          <AircraftOptionCard
            key={orderRequest.orderRequestId}
            order={order}
            orderRequest={orderRequest}
          />
        ))}
      </AircraftOptionsSection>
    )}
  </>

  const orderBrokerComponent = <OrderBroker>
    <OrderTypeShield type={order.type}/>
    <div>{DisplayFullName(order.user, "short")}</div>
  </OrderBroker>

  const companies = order.nestedOrderRequests.length > 0
    ? order.nestedOrderRequests.map(orderRequest => orderRequest.freighterCompany)
    : order.nestedEmptyLegs.map(emptyLeg => emptyLeg.freighterCompany);

  const handleFlag = () => {
    const newFavoriteState = !isFavorite;
    setIsFavorite(newFavoriteState);
    dispatch(updateOrderFavorite({
      orderId: order.id,
      isFavorite: newFavoriteState,
    }));
  };

  const handleDocumentSearch = () => {
    setIsPastResponsesModalOpen(true);
  };

  const handleDeclineAllOrderRequests = () => {
    const confirmMessage = intl.formatMessage(OrderHeaderMessages.confirmDeclineAllMessage);
    
    RenderConfirmModal(confirmMessage, async () => {
      // Archive the order - backend will automatically decline all order requests
      dispatch(archiveOrder({itemId: order.id}));
    }, intl);
  };

  useEffect(() => {
    if (!isDeclineLoading) {
      if (isDeclineSuccess) {
        dispatch(clearChangeOrderRequestWithdraw());
      } else if (declineErrorMessage) {
        antdMessage.error(declineErrorMessage);
        dispatch(clearChangeOrderRequestWithdraw());
      }
    }
  }, [isDeclineLoading, isDeclineSuccess, declineErrorMessage, intl, dispatch]);

  // Clear archive state on mount to prevent showing messages on page reload
  useEffect(() => {
    if (isArchiveSuccess && !isArchiveLoading) {
      dispatch(clearArchiveOrder());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!isArchiveLoading && isArchiveSuccess && !archiveHandledRef.current && order.isArchived) {
      // Only show message if order is actually archived and we haven't handled it yet
      archiveHandledRef.current = true;
      antdMessage.success(intl.formatMessage(OrderHeaderMessages.successDeclinedAndArchived));
      // Refresh the order list to reflect the changes (only once)
      dispatch(getChartererOrderList({
        page: 1,
        types: [],
        showArchived: false,
      }));
      // Refresh tab counters
      dispatch(getOrderListCounts({
        types: [],
      }));
      dispatch(clearArchiveOrder());
    } else if (!isArchiveLoading && archiveErrorMessage && !archiveHandledRef.current) {
      archiveHandledRef.current = true;
      antdMessage.error(archiveErrorMessage);
      dispatch(clearArchiveOrder());
    }
    
    // Reset the ref when archive loading starts (new action)
    if (isArchiveLoading) {
      archiveHandledRef.current = false;
    }
  }, [isArchiveLoading, isArchiveSuccess, archiveErrorMessage, order.isArchived, intl, dispatch]);

  return (
    <OrderHeaderWrapper>
      <OrderHeaderMainInfoWrapper>
        {isMobile && <OrderBrokerMobileWrapper>
          {orderBrokerComponent}
          <div style={{display: 'flex', gap: 8, alignItems: 'center'}}>
            {!order.isArchived && <>
              <ActionButtonWrapper onClick={handleDocumentSearch} heightSize={'m'}>
                <DocumentSearchIcon/>
              </ActionButtonWrapper>
              <FavoriteButtonWrapper
                heightSize={'m'}
                $isFavorite={isFavorite}
                icon={
                  isFavorite ? 
                    <FlagFilledIcon style={{color: "#1890FF"}}/> : 
                    <FlagIcon/>
                }
                onClick={handleFlag}
              />
              {order.nestedOrderRequests.length > 0 && order.nestedOrderRequests.some(
                (or: IChartererOrderRequestFromOrder) => or.status !== OrderRequestStatusEnum.DECLINED
              ) && (
                <DeclineButton
                  active={false}
                  onClick={handleDeclineAllOrderRequests}
                />
              )}
              <CustomButton icon={<CloseIcon/>} style={{width: 45, height: 35, background: "#FAFAFA"}}
                            onClick={() => setIsArchiveModalOpen(true)}/>
            </>}
          </div>
        </OrderBrokerMobileWrapper>}

        {!isMobile && <>
          {orderBrokerComponent}
          <VerticalDivider/>
        </>}

        <OrderHeaderMainInfoItem style={{width: isMobile ? "100%" : 320}}>
          <div>
            {formatDate(firstRoute.departureDate, offset, isOnlyRoute ? "datetime" : "date")}
            {!isOnlyRoute && ` – ${formatDate(lastRoute.departureDate, offset, "date")}`}
          </div>
          <FlyRouteMini airports={allOrderAirports} onMoreClick={() => setIsMoreInfoExpanded(prev => !prev)}/>
        </OrderHeaderMainInfoItem>

        {!isMobile &&
          <>
            <VerticalDivider/>

            <OrderHeaderMainInfoItem style={{flexGrow: 1}}>
              <div>{intl.formatMessage(OrderHeaderMessages.companies)}</div>
              <FlyCompanies companies={companies}/>
            </OrderHeaderMainInfoItem>

            <VerticalDivider/>

            <OrderHeaderMainInfoItem>
              <div>{intl.formatMessage(OrderHeaderMessages.dateCreated)}</div>
              <div>{formatDate(order.createdDate, offset, "date")}</div>
            </OrderHeaderMainInfoItem>

            <VerticalDivider/>

            <ArchiveSection>
              {!order.isArchived && <>
                <ActionButtonWrapper onClick={handleDocumentSearch} heightSize={'m'}>
                  <DocumentSearchIcon/>
                </ActionButtonWrapper>
                <FavoriteButtonWrapper
                  heightSize={'m'}
                  $isFavorite={isFavorite}
                  icon={
                    isFavorite ? 
                      <FlagFilledIcon style={{color: "#1890FF"}}/> : 
                      <FlagIcon/>
                  }
                  onClick={handleFlag}
                />
                {order.nestedOrderRequests.length > 0 && order.nestedOrderRequests.some(
                  (or: IChartererOrderRequestFromOrder) => or.status !== OrderRequestStatusEnum.DECLINED
                ) && (
                  <DeclineButton
                    active={false}
                    onClick={handleDeclineAllOrderRequests}
                  />
                )}
                <CustomLinkButton icon={<CloseIcon/>} onClick={() => setIsArchiveModalOpen(true)}>
                  {intl.formatMessage(CommonButtonMessages.cancelRequest)}
                </CustomLinkButton>
              </>}
              <div onClick={() => setIsMoreInfoExpanded(prev => !prev)}>
                {isMoreInfoExpanded ? <CollapseIcon/> : <ExpandIcon/>}
              </div>
            </ArchiveSection>
          </>
        }
      </OrderHeaderMainInfoWrapper>

      {isMoreInfoExpanded && moreInfo}

      {isMobile && <MoreInfoMobileButton>
        <div
          onClick={() => setIsMoreInfoExpanded(prev => !prev)}>{intl.formatMessage(CommonButtonMessages.allDetails)}</div>
        {isMoreInfoExpanded ? <CollapseIcon/> : <ExpandIcon/>}
      </MoreInfoMobileButton>}

      {isArchiveModalOpen && <ArchiveOrderModal orderId={order.id} isModalVisible={isArchiveModalOpen}
                                                setIsModalVisible={setIsArchiveModalOpen}/>}

      {isPastResponsesModalOpen && (
        <PastResponsesModal
          visible={isPastResponsesModalOpen}
          onClose={() => setIsPastResponsesModalOpen(false)}
          routeFrom={firstRoute.airportFrom}
          routeTo={lastRoute.airportTo}
          allRouteAirports={allOrderAirports}
          orderId={order.id}
        />
      )}
    </OrderHeaderWrapper>
  );
};


const FlyRouteBigCard: FC<{ orderRoute: IFreighterOrderRoute }> = ({orderRoute}) => {
  const intl = useIntl();
  const offset = useUserTimezoneOffset();

  return <FlyRouteBigCardWrapper>
    <FlyRouteBigCardRoutesSection>
      <div>
        <div>{intl.formatMessage(CommonDetailsMessages.from)}</div>
        <div>{formatDate(orderRoute.departureDate, offset, "datetime")}</div>
        <div>
          <div>{DisplayAirport(orderRoute.airportFrom, "codes")}</div>
          <div>({DisplayAirport(orderRoute.airportFrom, "location_and_name")})</div>
        </div>
      </div>
      <RouteArrowIcon/>
      <div>
        <div>{intl.formatMessage(CommonDetailsMessages.to)}</div>
        <div>
          <div>{DisplayAirport(orderRoute.airportTo, "codes")}</div>
          <div>({DisplayAirport(orderRoute.airportTo, "location_and_name")})</div>
        </div>
      </div>
    </FlyRouteBigCardRoutesSection>

    <VerticalDivider/>

    <FlyRouteBigCardPaxSection>
      <div>{intl.formatMessage(CommonDetailsMessages.pax)}</div>
      <div>
        <PaxIcon/>
        <div>{orderRoute.pax}</div>
      </div>
    </FlyRouteBigCardPaxSection>
  </FlyRouteBigCardWrapper>
}

const FlyRouteSmallCard: FC<{ orderRoute: IFreighterOrderRoute }> = ({orderRoute}) => {
  const intl = useIntl();
  const offset = useUserTimezoneOffset();

  return <FlyRouteSmallCardWrapper>
    <div>
      <div>{formatDate(orderRoute.departureDate, offset, "datetime")}</div>
      <div>
        <div>{DisplayAirport(orderRoute.airportFrom, "codes")}</div>
        <RouteMiniArrowIcon/>
        <div>{DisplayAirport(orderRoute.airportTo, "codes")}</div>
      </div>
    </div>

    <div>
      <div>{intl.formatMessage(CommonDetailsMessages.pax)}</div>
      <div>
        <PaxIcon/>
        <div>{orderRoute.pax}</div>
      </div>
    </div>
  </FlyRouteSmallCardWrapper>
}
